import { type ICongratsModalProps, emitter } from "@lobby/core/src/shared";
import { useTranslate } from "@lobby/ocb-intl";
import { skipIntl } from "@lobby/utils-formatters";
import { clsx } from "clsx";
import { JackpotDecorator } from "entities/jackpot";
import { useEffect, useState } from "react";
import { Modal } from "shared/ui/modal/modal";

export function CongratsModal() {
  const { $t } = useTranslate();

  const [isOpened, setIsOpened] = useState(false);
  const [params, setParams] = useState<ICongratsModalProps>({} as ICongratsModalProps);

  const { message, value, colors, onTake } = params ?? {};
  const [primaryColor, secondaryColor] = colors ?? [];

  function handleTake() {
    onTake();
    setIsOpened(false);
  }

  useEffect(() => {
    const unbind = emitter.on("CONGRATS_MODAL_OPEN", (params) => {
      setParams(params);
      setIsOpened(true);
    });

    return unbind;
  }, []);

  return (
    <Modal open={isOpened}>
      <Modal.Overlay />
      <Modal.Panel className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div
          className={clsx(
            "lg:p-2.5 lg:rounded-tl-[5.25rem] lg:rounded-br-[5.25rem] rounded-rounded rounded-tl-[3rem] rounded-br-[3rem] border-1 p-1.5 relative w-max max-w-[90vw]",
          )}
          style={{
            backgroundColor: primaryColor + "4d",
            borderColor: primaryColor,
          }}
        >
          <div className="absolute lg:top-[-1.25rem] lg:right-[-3.75rem] -top-3 -right-10">
            <JackpotDecorator className="lg:w-[12.5rem] w-28" gradient={colors} />
          </div>
          <div
            className={clsx(
              "lg:rounded-tl-[4.9375rem] lg:rounded-br-[4.9375rem] rounded-tl-[2.625rem] rounded-br-[2.625rem] rounded-inherit",
            )}
            style={{
              backgroundImage: `linear-gradient(to bottom, ${primaryColor}, ${secondaryColor})`,
            }}
          >
            <div className="lg:gap-5 lg:p-10 gap-2.5 p-5 text-center flex flex-col">
              <div className="lg:text-4xl text-xl font-extrabold italic uppercase font-commissioner tracking-wider text-white [text-shadow:0.25rem_0.25rem_0_rgba(0,0,0,0.3)]">
                {$t({ defaultMessage: "congrats" }).toUpperCase()}
                {skipIntl("!")}
              </div>
              <p className="lg:text-2xl text-lg font-bold uppercase text-white whitespace-pre-line">
                {message}
              </p>
              <div className="lg:text-4xl text-2xl font-extrabold italic uppercase font-commissioner tracking-wider text-white [text-shadow:0.25rem_0.25rem_0_rgba(0,0,0,0.3)]">
                {value}
              </div>
              <div>
                <button
                  className="lg:text-sm lg:px-7.5 lg:h-9 lg:active:translate-x-[0.5rem] lg:active:translate-y-[0.5rem] lg:[box-shadow:0.5rem_0.5rem_0_rgba(0,0,0,0.25)] active:translate-x-[0.375rem] active:translate-y-[0.375rem] [box-shadow:0.375rem_0.375rem_0_rgba(0,0,0,0.25)] text-xs px-4 py-2 min-w-18 bg-java rounded-rounded text-ebony-clay font-bold uppercase  whitespace-nowrap hover:text-white active:[box-shadow:none]"
                  type="button"
                  onClick={handleTake}
                >
                  {$t({ defaultMessage: "take" })}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Panel>
    </Modal>
  );
}
